export default [
  {
    path: '/test-table',
    name: 'air-service-employee-testtable',
    components: {
      navigation: () => import('@/components/air-service/common/header.vue'),
      default: () => import('@/pages/index/test-table.vue')
    },
    meta: {
      belong: 'air-service'
    }
  },
  // 共享评分详情
  {
    path: '/score-detail',
    name: 'air-service-employee-scoredetail',
    components: {
      navigation: () => import('@/components/air-service/common/header.vue'),
      default: () => import('@/pages/index/score-detail.vue')
    },
    meta: {
      belong: 'air-service'
    }
  },
  // 消息详情
  {
    path: '/news-detail',
    name: 'air-service-employee-newsdetail',
    components: {
      navigation: () => import('@/components/air-service/common/header.vue'),
      default: () => import('@/pages/index/news-detail.vue')
    },
    meta: {
      belong: 'air-service'
    }
  },
  // 各类单据申请以及详情
  {
    path: '/air-service/employee/:type/:state/:billKey',
    name: 'air-service-employee-application-type',
    components: {
      navigation: () => import('@/components/air-service/common/header.vue'),
      default: () => import('@/pages/dev-demo/applications/application-type.vue')
    },
    meta: {
      belong: 'air-service'
    }
  },
  // 单据中心
  {
    path: '/air-service/employee/applications',
    name: 'air-service-employee-applications',
    components: {
      navigation: () => import('@/components/air-service/common/header.vue'),
      default: () => import('@/pages/dev-demo/applications/index.vue')
    },
    meta: {
      belong: 'air-service'
    }
  },
  // 审批中心
  {
    path: '/air-service/employee/approve',
    name: 'air-service-employee-approve',
    components: {
      navigation: () => import('@/components/air-service/common/header.vue'),
      default: () => import('@/pages/dev-demo/approve/approve.vue')
    },
    meta: {
      belong: 'air-service'
    }
  },
  // 登录
  {
    path: '/',
    name: 'Index',
    redirect: '/qwLogin'
  },
  {
    path: '/login',
    name: 'Login',
    components: {
      default: () => import('@/pages/index/login.vue')
    },
    meta: {
      belong: 'air-service'
    }
  },
  {
    path: '/authLogin',
    name: 'authLogin',
    components: {
      default: () => import('@/pages/index/authLogin.vue')
    },
    meta: {
      belong: 'air-service'
    }
  },
  {
    path: '/qwLogin',
    name: 'qwLogin',
    components: {
      default: () => import('@/pages/index/qwLogin.vue')
    },
    meta: {
      belong: 'air-service'
    }
  },
  // 员工自助
  {
    path: '/air-service/employee/home',
    name: 'air-service-employee-home',
    components: {
      navigation: () => import('@/components/air-service/common/header.vue'),
      default: () => import('@/pages/air-service/employee/home/index.vue')
    },
    meta: {
      belong: 'air-service'
    }
  },
  // 入职地图
  {
    path: '/inductionmap',
    name: 'inductionmap',
    components: {
      default: () => import('@/pages/index/inductionmap.vue')
    }
  },
  {
    path: '/air-service/employee/personal-information',
    name: 'air-service-employee-personal-information',
    components: {
      navigation: () => import('@/components/air-service/common/header.vue'),
      default: () => import('@/pages/air-service/employee/personal-information/index.vue')
    },
    meta: {
      belong: 'air-service'
    }
  },
  // 经理自助
  {
    path: '/air-service/manager/home',
    name: 'air-service-manager-home',
    components: {
      navigation: () => import('@/components/air-service/common/header.vue'),
      default: () => import('@/pages/air-service/manager/home/index.vue')
    },
    meta: {
      belong: 'air-service'
    }
  },
  {
    path: '/air-service/manager/basic-information',
    name: 'air-service-manager-basic-information',
    components: {
      navigation: () => import('@/components/air-service/common/header.vue'),
      default: () => import('@/pages/air-service/manager/basic-information/index.vue')
    },
    meta: {
      belong: 'air-service'
    }
  },
  {
    path: '/air-service/manager/personnel-viewing',
    name: 'air-service-manager-personnel-viewing', // 人员一览区
    components: {
      navigation: () => import('@/components/air-service/common/header.vue'),
      default: () => import('@/pages/air-service/manager/personnel-viewing/index.vue')
    },
    meta: {
      belong: 'air-service'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/air-service.js